import "../sections/sections.css";
import "./travel.css";

import React from "react";

import { TRAVEL } from "../../data/travel";
import PageMeta from "../general/PageMeta";
import SectionTitle from "../general/SectionTitle";
import PageHero from "../sections/PageHero";

const PackageLink = ({ offering, className }) => (
  <a
    href={offering.pdf}
    target={"_blank"}
    rel={"noopener noreferrer"}
    className={`travel-package ${className || ""}`}
  >
    <img
      src={offering.src}
      alt={offering.alt}
      width={offering.width}
      height={offering.height}
      loading={"lazy"}
    />
    <span className={"travel-package-label"}>View package (PDF)</span>
  </a>
);

const Travel = () => (
  <React.Fragment>
    <PageMeta
      title={"Travel"}
      description={TRAVEL.TYPES[0].text}
    />
    <PageHero {...TRAVEL.HERO} />

    <section className={"travel-types"}>
      <div className={"container"}>
        <ul className={"travel-types-grid"}>
          {TRAVEL.TYPES.map((type) => (
            <li key={type.title}>
              <img
                src={type.image.src}
                alt={type.image.alt}
                width={type.image.width}
                height={type.image.height}
                className={"card-image"}
                loading={"lazy"}
              />
              <h2 className={"card-title"}>{type.title}</h2>
              <p className={"card-text"}>{type.text}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>

    <section
      className={"travel-offerings"}
      aria-labelledby={"offerings-title"}
    >
      <div className={"container-wide"}>
        <div className={"section-heading"}>
          <h2
            id={"offerings-title"}
            className={"section-title"}
          >
            {TRAVEL.OFFERINGS_TITLE}
          </h2>
          <p className={"travel-offerings-text"}>{TRAVEL.OFFERINGS_TEXT}</p>
        </div>
        <PackageLink
          offering={TRAVEL.FEATURED}
          className={"is-featured"}
        />
        <ul className={"travel-packages"}>
          {TRAVEL.OFFERINGS.map((offering) => (
            <li key={offering.pdf}>
              <PackageLink offering={offering} />
            </li>
          ))}
        </ul>
      </div>
    </section>

    <section className={"travel-recommend"}>
      <div className={"container"}>
        <h2 className={"section-title travel-recommend-title"}>{TRAVEL.RECOMMEND_TITLE}</h2>
        {TRAVEL.RECOMMENDATIONS.map((item) => (
          <article
            key={item.title}
            className={"travel-recommendation"}
          >
            <SectionTitle as={"h3"}>{item.title}</SectionTitle>
            <div className={"travel-recommendation-body"}>
              <img
                src={item.image.src}
                alt={item.image.alt}
                width={item.image.width}
                height={item.image.height}
                loading={"lazy"}
              />
              <div className={"travel-recommendation-text"}>
                {item.paragraphs.map((p) => <p key={p}>{p}</p>)}
                {item.emailText ? (
                  <p>
                    {item.emailText[0]}
                    <a href={`mailto:${item.emailText[1]}`}>{item.emailText[1]}</a>
                    {item.emailText[2]}
                  </p>
                ) : null}
                <div className={"travel-recommendation-buttons"}>
                  <a
                    href={item.website}
                    target={"_blank"}
                    rel={"noopener noreferrer"}
                    className={"btn"}
                  >
                    View Website
                  </a>
                  <a
                    href={`mailto:${TRAVEL.EMAIL}?subject=${encodeURIComponent(item.title)}`}
                    className={"btn"}
                  >
                    Contact Us
                  </a>
                </div>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>

    <section className={"travel-interested"}>
      <div className={"container"}>
        <SectionTitle>{TRAVEL.INTERESTED_TITLE}</SectionTitle>
        <p className={"section-intro"}>{TRAVEL.INTERESTED_TEXT}</p>
        <div className={"btn-row"}>
          <a
            href={`mailto:${TRAVEL.EMAIL}`}
            className={"btn travel-email-button"}
          >
            {TRAVEL.EMAIL}
          </a>
        </div>
      </div>
    </section>
  </React.Fragment>
);

export default Travel;
